import React, { useEffect, useRef, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import "../styles/AppDropdown.css";

/**
 * Shared styled dropdown — dark rounded panel with highlighted active option
 * (same look as the Add User department dropdown).
 *
 * options: [{ value, label }]
 */
const AppDropdown = ({ options = [], value, onChange, placeholder = "Select...", className = "", align = "left" }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onOutside);
    return () => document.removeEventListener("mousedown", onOutside);
  }, [open]);

  const selected = options.find((o) => String(o.value) === String(value));

  return (
    <div className={`appdd ${className}`} ref={wrapRef}>
      <button
        type="button"
        className={open ? "appdd__trigger open" : "appdd__trigger"}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="appdd__value">{selected ? selected.label : placeholder}</span>
        <FaChevronDown className={open ? "appdd__icon open" : "appdd__icon"} />
      </button>

      {open ? (
        <div className={`appdd__menu appdd__menu--${align}`} role="listbox">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              role="option"
              aria-selected={String(option.value) === String(value)}
              className={String(option.value) === String(value) ? "appdd__item active" : "appdd__item"}
              onClick={() => {
                onChange(option.value);
                setOpen(false);
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default AppDropdown;
